module.exports = __webpack_public_path__ + "static/media/interestPointMarker.22ff3b93.svg";